import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/firestore';
const firebaseConfig = {
    apiKey: "AIzaSyD67H1d_PyXEwJNtB7JM-YgmrKXpyJJ26A",
    authDomain: "arc-ams.firebaseapp.com",
    databaseURL: "https://arc-ams.firebaseio.com",
    projectId: "arc-ams",
    storageBucket: "arc-ams.appspot.com",
    messagingSenderId: "565382930119",
    appId: "1:565382930119:web:6fe6555a7f5859ba98a8e2",
    measurementId: "G-C1CQC3PMM2"
};
firebase.initializeApp(firebaseConfig);
firebase.analytics();
export default firebase;
export function googleAuthProvider() {
    return new firebase.auth.GoogleAuthProvider();
}
